import React from "react";
import MUICard from "@mui/material/Card";
import type { CardProps } from "@mui/material/Card";

import { TestProps } from "shared/types";

interface Props extends CardProps, TestProps {
  children?: React.ReactNode;
}

const Card = ({ testId, ...props }: Props) => (
  <MUICard data-testid={testId} {...props} />
);

export default Card;
